import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { routes } from './app/app.routes'; // ✅ this should export your standalone route array
import { AppComponent } from './app/app-component';
import 'zone.js';
import { environment } from './environments/environment';

console.log('App bootstrapping with Auth API URL:', environment.authApiBase);
console.log('App bootstrapping with Data API URL:', environment.dataApiBase);

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideHttpClient(),
    importProvidersFrom(FormsModule)
  ]
});
